import { api } from "@/api/axios";

export type PlatformUserRole = "PLATFORM_ADMIN";

export interface PlatformUser {
  id: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  role: PlatformUserRole;
  is_active: boolean;
  last_login_at?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface PlatformLoginRequest {
  email: string;
  password: string;
}

export interface PlatformLoginResponse {
  access_token: string;
  token_type: string;
  user: PlatformUser;
}

export async function loginPlatformUser(
  data: PlatformLoginRequest,
): Promise<PlatformLoginResponse> {
  const response = await api.post<PlatformLoginResponse>(
    "/api/platform/auth/login",
    data,
  );

  return response.data;
}

export async function getCurrentPlatformUser(): Promise<PlatformUser> {
  const response = await api.get<PlatformUser>(
    "/api/platform/auth/me",
  );

  return response.data;
}